export default "__VITE_ASSET__D$QbaaUO__"